import { useCallback, useContext } from "react";

import { useAsyncCall, useMutation } from "hooks";
import { createResolverFactory } from "components/QueryClient/ResolverFactory";

import { ToasterContext } from "scenes/Hubly/components/Workspace/Provider";

const useUpdatePractice = (onDone) => {
  const mutationFactory = useCallback(() => {
    const query = `mutation updatePractice($name: String!, $accountOwnerId: ID!) {
            updatePractice(name: $name, accountOwnerId: $accountOwnerId) {
              practice {
                uuid
                name
              }
            }
          }`;

    const resolver = ({ data: { updatePractice } }) => {
      return { practice: updatePractice.practice };
    };

    return { query: query, resolver: createResolverFactory(resolver) };
  }, []);

  const generateErrorMessage = (err) => {
    if (Array.isArray(err) && err[0]?.message) return err[0].message;

    return "Failed to update practice";
  };

  const [call, connecting] = useAsyncCall();
  const updatePractice = useMutation(mutationFactory);
  const { fireError } = useContext(ToasterContext);

  return {
    loading: connecting,
    updatePractice: (name, accountOwnerId) => {
      return call(async () => {
        try {
          await updatePractice({ name, accountOwnerId });
          onDone();
        } catch (err) {
          fireError(generateErrorMessage(err));
        }
      });
    },
  };
};

export default useUpdatePractice;
